module.exports = __webpack_public_path__ + "img/special-3.86616d2d.png";